// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-data-warning {
  padding: 12px 0;
}

.delete-data-success-message {
  padding: 12px 16px;
  background-color: #e6f9e6;
  background-color: var(--color-status-ok-bg, #e6f9e6);
  border-radius: 6px;
}

.delete-data-error-message {
  padding: 12px 16px;
  background-color: var(--color-status-alert-96);
  background-color: var(--color-status-alert-96);
  border-radius: 6px;
  color: var(--color-danger-idel);
  color: var(--color-danger-idel);
}

.delete-data-confirm-section {
  padding: 16px 0;
}
`, "",{"version":3,"sources":["webpack://./app/components/deleteData/DeleteData.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,8CAA8C;EAC9C,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".delete-data-warning {\n  padding: 12px 0;\n}\n\n.delete-data-success-message {\n  padding: 12px 16px;\n  background-color: #e6f9e6;\n  background-color: var(--color-status-ok-bg, #e6f9e6);\n  border-radius: 6px;\n}\n\n.delete-data-error-message {\n  padding: 12px 16px;\n  background-color: var(--color-status-alert-96);\n  background-color: var(--color-status-alert-96);\n  border-radius: 6px;\n  color: var(--color-danger-idel);\n  color: var(--color-danger-idel);\n}\n\n.delete-data-confirm-section {\n  padding: 16px 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
